import { SourceQuote } from '@/app/components/testing-plan/components/test-details/types';
import { handleExternalLink } from '@/utils/link-props';
import { Box, Button, IconArrowDown, Link, Text } from '@cmpsr/components';
import { PropsWithChildren } from 'react';

type SourceQuoteTagProps = PropsWithChildren<{
  sources: Array<SourceQuote>;
  showLoadMoreButton?: boolean;
  loadMore?: () => void;
}>;

export default function SourceQuoteTag({ sources, showLoadMoreButton, loadMore }: SourceQuoteTagProps) {
  if (!sources || !sources.length) return null;

  return (
    <Box
      display="flex"
      flexDir="column"
      gap="spacer-4"
      p={5}
      border="1px solid"
      borderColor="ui-element-divider"
      borderRadius="radii-3"
    >
      {sources.map((item, index) => (
        <Text variant="text-body-meta-regular" color="text-secondary" key={index}>
          {item.description}
          {item.url && (
            <Link
              target="_blank"
              size="s"
              color="text-secondary"
              textDecoration="underline"
              ml="spacer-2"
              {...handleExternalLink({ href: item.url })}
            >
              Read more
            </Link>
          )}
        </Text>
      ))}
      {showLoadMoreButton && (
        <Button
          onClick={loadMore}
          variant="ghost"
          size="s"
          w="full"
          mt="spacer-2"
          trailingIcon={<IconArrowDown size="s" />}
          border="1px solid"
          borderColor="ui-element-divider"
          borderRadius="radii-3"
        >
          Load more
        </Button>
      )}
    </Box>
  );
}
